// =======================================================
// PREBOOT — SE EJECUTA ANTES DE TODO
// =======================================================

import { set_member_reference } from "./members_reference.js";
import { showPreloader } from "../ui/preloader.js";

// ⚠️ NADA DE DOM, NADA DE UI
// solo URL → localStorage
showPreloader();
set_member_reference();



console.log("🧠 Preboot references initialized");